(ns com.theplantscape.plant-web.draw.ui-form
  (:require
   [clojure.set :refer [rename-keys]]
   [clojure.string :as str]
   [com.theplantscape.plant-web.api.plants
    :refer [add-new-plant add-new-plant-image]]
   [com.theplantscape.plant-web.components.forms.core
    :refer [append-atom-hm! fetch-atom-hm fmt-opt-from-keyword update-atom-hm]]
   [com.theplantscape.plant-web.components.tailwind.buttons
    :refer [button-progress-ajax]]
   [com.theplantscape.plant-web.components.tailwind.icons.image-upload
    :refer [icon-image-upload]]
   [com.theplantscape.plant-web.draw.constants
    :as con
    :refer [do-plant-api
            hardiness-options
            lifecycle-options
            months-options
            units-options]]
   [com.theplantscape.plant-web.draw.state
    :refer [app-state site-data site-state]]
   [com.theplantscape.plant-web.pages.plant-layouts :refer [change-page]]
   [com.theplantscape.web-ui.tailwind.ensemble :as gps :refer [ui-btn-action]]
   [com.theplantscape.web-ui.tailwind.form.elements.input :as f]
   [com.theplantscape.web-ui.tailwind.form.elements.select :as s]
   [reagent.core :as r]))

(def str-uuid? (comp uuid? uuid str))
(def fmt-plant-types->options (fn [] (map (fn [v] [v (fmt-opt-from-keyword v)]) (-> @site-data :plant-types))))
(def current-value (fn [name values] ((keyword name) values)))

(defn js-files->list [js-col]
  (-> (clj->js [])
      (.-slice)
      (.call js-col)
      (js->clj)))

#_(defn img-path [image-id format]
    (str (:path img) image-id format))

(defn tw-search-input []
  [:div.flex.space-x-4
   [:div.flex.rounded-md.overflow-hidden.w-full
    [:input.w-full.rounded-md.rounded-r-none {:type "text"}]
    [:button.bg-indigo-600.text-white.px-6.text-lg.font-semibold.py-4.rounded-r-md "Go"]]
   [:button.bg-white.px-6.text-lg.font-semibold.py-4.rounded-md "Clear"]])

(defn act [e func & params]
  (.preventDefault e)
  (apply func params))

(defn remove-image [e values image]
  (swap! values assoc-in [:values :plant.images/examples]
         (disj (-> @values :values :plant.images/examples) image)))

(defn image-preview [values {:keys [title image alt] :as img}]
  [:div.fl.w-50.w-25-m.w-20-l.pa2.relative
   (when (:remove img))
   [:span.absolute.top-0 [:i.far.fa-times-circle {:on-click (fn [e] (remove-image e values image))}]]
   [:img.w-100.outline.black-10.top-0
    {:src
     (cond
       (nil? image) "images/default2.jpg"
       (str-uuid? image) (str (:path img) image ".jpg")
       :else image)
     :alt alt
     :class (:class img)}]
   [:dl.w-100.mt2.f6.lh-copy [:dt.clip "Title"]
    [:dd.ml0.text-xs.black.truncate.w-100 title]
    (when (:uploaded img)
      [:dt.clip "Uploaded"]
      [:dd.ml0.gray.truncate.w-100 "50%"])]])

(defn build-form [params]
  "Quickly build a js form from a hash map."
  (let [form-data (js/FormData.)]
    (doseq [[k v] params]
      (.append form-data (name k) v))
    form-data))

(defn store-image-id-after-upload [name values new-value]
  (append-atom-hm! values (keyword name) (:name new-value))
  #_#_(when-not  (name @values) (swap! values assoc name #{}))
    (swap! values assoc-in [:values name] (conj (-> @values :values name) (:name new-value))))

(defn handle-dropped-file-loaded [values uploads f name]
  ;;(fn [e])
  (prn "upload read url")
  (add-new-plant-image
   (build-form  (select-keys f [:file]))
   (fn [upload-complete]
     (prn "upload complete")
     (append-atom-hm! values  (keyword name) (:name upload-complete))
     #_(store-image-id-after-upload name values upload-complete)
     ;;(swap! uploads (disj @uploads f))
     (swap! uploads dissoc (:name f) @uploads)))
  #_(swap! uploads assoc-in [idx :data] e))

(defn create-onload-reader
  "Create a js reader with an onload event"
  [callback]
  (let [reader (js/FileReader.)]
    (set! (.-onload reader) callback)
    reader))

(defn handle-droped-file
  "Add a reader object to a hashmap with a onload callback"
  [values uploads name f]
  (let [filemap {:file f
                 :name (.-name f)
                 :uploaded false}]
    (.readAsDataURL
     (create-onload-reader
      (fn [evt]
        (swap! uploads assoc-in  [(:name filemap) :data] (-> evt .-target .-result))
        (handle-dropped-file-loaded values uploads filemap name)))
     (:file filemap))
    {(.-name f) filemap}))

#_(defn handle-droped-file [f]
    {(.-name f) {:file f :name (.-name f) :uploaded false}})

(defn handle-input-files [evt values uploads name]
  (.preventDefault evt)
  (prn (-> evt .-target .-files #_(aget 0)))
  (let [files-raw  (-> evt .-target .-files #_(aget 0)) #_(aget evt "dataTransfer" "files")]
    (prn "handle dropped files")
    (prn files-raw)
    (prn (js-files->list files-raw))
    (reset! uploads
            (->> (js-files->list files-raw)
                 (mapv (partial handle-droped-file values uploads name))
                 (into {})))))

(defn handle-dropped-files [evt values uploads name]
  (.preventDefault evt)
  (prn (-> evt .-target .-files #_(aget 0)))
  (prn (aget evt "dataTransfer" "files"))
  (let [files-raw  (aget evt "dataTransfer" "files")]
    (prn "handle dropped files")
    (prn files-raw)
    (prn (js-files->list files-raw))
    (reset! uploads
            (->> (js-files->list files-raw)
                 (mapv (partial handle-droped-file values uploads name))
                 (into {})))))

(defn ui-image-drop [label name values form]
  (let [focus (r/atom false)
        uploads (r/atom {})]
    (fn [label name values form]
      [:div.w-100 {:class (when @focus "bg-red")
                   :on-drag-enter #(reset! focus true)
                   :on-drag-leave #(reset! focus false)
                   :on-drag-over #(.preventDefault %)
                   :on-drop #(handle-dropped-files %1 values uploads name)}

       [:label.w-full.h-full.block {:for name}
        [:input.hidden {:id name
                        :on-change #(handle-input-files %1 values uploads name)
                        :name name
                        :type "file" :accept "image/*"}]

        [:article.mt-1.flex.justify-center.px-6.pt-5.pb-6.border-2.border-gray-300.border-dashed.rounded-md
                                        ;(str @uploads)
         (when (and (empty? @uploads) (empty? ((keyword name) (:values @values))))
           [:div.space-y-1.text-center
            [icon-image-upload]
            [:span.flex.f2.fw4.pa3.mv0.pa0.ma0.w-100.h-40 label]])
         [:div.cf.pa2.cf:after
          (map-indexed
           (fn [idx file-ob]
             [:<> {:key file-ob}
              (image-preview
               values
               {:title file-ob
                :path (str do-plant-api "/plants/images/")
                :image file-ob})])
           ((keyword name) (:values @values)))
          (map
           (fn [[name file-ob]]
             [:<> {:key name}
              (image-preview
               values
               {:title (:name file-ob)
                :alt (:name file-ob)
                :class (when-not (:uploaded file-ob) "o-60")
                :image (:data file-ob)})]) @uploads)]]]])))

(defn ui-period [label-start name-start label-end name-end form]
  [:div.mt3
   [:span.w-50
    [:label.fw6.lh-copy.f6 {:for name-start} label-start]
    [:input.pa2.input-reset.ba.bg-transparent.hover-bg-black.hover-white
     {:type "date" :name name-start
      :on-change form}]]
   [:span.w-50
    [:label.fw6.lh-copy.f6 {:for name-end} label-end]
    [:input.pa2.input-reset.ba.bg-transparent.hover-bg-black.hover-white
     {:type "date" :name name-end
      :on-change form}]]])

(defn ui-button [label values callback]
  [:button {:on-click (fn [evt] (.preventDefault evt)
                        (callback (:values @values)))} label])

(defn ui-hidden
  ([name form] (ui-hidden name nil form))
  ([name value form]
   [:input
    {:type "hidden" :name name
     :default-value (fetch-atom-hm value (keyword name))
     :on-change form}]))

(defn ui-input-inline-fn
  [name opts]
  [:span {:class (:class opts)}
   (when (:label opts)
     [:label {:for name :class (or (:label-classes opts) "fw6 lh-copy f6")} (:label opts)])
   [:input.input-reset.p-2
    {:type "text"
     :class (or (:input-classes opts) "")
     :name name
     :placeholder (:label opts)
     :default-value (or (:default-value-fn opts) "")
     :on-change (:on-change-fn opts)}]])

(defn ui-input-fn
  [label name opts]
  [:div
   [:label {:for name :class (or (:label-classes opts) "mb-2 fw6 lh-copy f6")} label]
   [:input
    {:type "text" :name name
     :class (or (:input-classes opts) "")
     :default-value (:default-value-fn opts)
     :on-change (:on-change-fn opts)}]])

(defn ui-input
  ([label name form] (ui-input label name nil form))
  ([label name value form]
   [:div.w-100.flex.m-2
    [:div {:class "w-1/3"}
     [:label {:for name} label]]
    [:input.w-full.rounded-md.rounded-r-none
     {:class "w-2/3" :type "text" :name name
      :default-value (fetch-atom-hm value (keyword name))
      :on-change form}]]))

(defn ui-select-ordered [label node-name node-value order options form]
  [:div.m-4.flex
   [:div {:class "w-1/3"}
    [:label {:for "type"} label]]
   [:select
    {:type "text" :name node-name :on-change form
     :default-value  (fetch-atom-hm node-value node-name)}
    (map (fn [value]
           [:option {:value value :key value} (value options)])
         order)]])

(defn ui-select-inline-fn [node-name options opts]
  [:select
   {:type "text" :name node-name :on-change (:on-change-fn opts)
    :class (or (:input-classes opts) "")

    :default-value (:default-value-fn opts)}
   (map (fn [[value text]]
          [:option.pa2 {:value value :key value} text])
        options)])

(defn ui-select-fn [label node-name options opts]
  [:div.w-50.ma0.flex
   [:div {:class "w-1/3"}
    [:label.fw6.lh-copy.f6 {:for "type"} label]]
   [:select.pa2.input-reset.ba.bg-transparent.hover-bg-black.hover-white.w-100
    {:type "text" :name node-name :on-change (:on-change-fn opts)
     :default-value (:default-value-fn opts)}
    (map (fn [[value text]]
           [:option {:value value :key value} text])
         options)]])

(defn ui-select [label node-name node-value options form]
  [:div.w-100.flex.m-4
   [:div {:class "w-1/3"}
    [:label {:for "type"} label]]
   [:select
    {:class "w-2/3" :type "text" :name node-name :on-change form
     :default-value (current-value node-name @node-value)}
    (map (fn [[value text]]
           [:option {:value value :key value} text])
         options)]])

(defn ui-months [label path values]
  (let [;;selected (r/cursor values [:values path])
        get-value (fn [key]
                    (get-in @values [:values path key ]))
        set-value (partial update-atom-hm values [:values path])
        set-value-clean (fn  [evt]
                          ;; Adjusted to clear start end value when not set
                          (if (= 0 (-> evt .-target .-value count) )
                            (set-value nil (-> evt .-target .-name) nil)
                            (set-value evt))
                          (when (every? #(= % nil) (vals (get-in @values [:values path])))
                            (update-atom-hm values [:values] nil path nil)))]
    (fn []
      [:div
       [:div.fw6.lh-copy.f6 label]
       [s/ui-form-select-inline-fn
        {:name :start
         :label "Start"
         :get-value get-value
         :set-value set-value-clean
         :options months-options}]

       [s/ui-form-select-inline-fn 
        {:name :end
         :label "End"
         :get-value get-value
         :set-value set-value-clean
         :options months-options}]])))

(defn reset-form!
  ([state path] (reset-form! state path {}))
  ([state path defaults]
   (swap! state assoc-in path defaults)
   (r/cursor state path)))

(defn replace-slash-in-map-keys [m]
  (rename-keys m
               (zipmap (-> @app-state :plant :plant keys)
                       (map #(keyword (str/replace (subs (str %) 1) #"/" "|"))
                            (keys m)))))

(defn ui-form-plant
  ([] (ui-form-plant nil))
  ([identifier]
   (let [current-tab (r/atom nil)
         plant (r/cursor app-state [:plant :plant])
         values (reset-form! site-state [:current-form]
                             {:values
                              (or
                               (replace-slash-in-map-keys
                                @plant)
                               {:plant|type "vine"
                                ;; :plant.season/sowing {}
                                ;; :plant.season/planting {}
                                ;; :plant.season/flowering {}
                                ;; :plant.season/fruiting {}
                                })})
         ;durations (r/atom false)
         form (partial update-atom-hm values)
         valid (r/atom false)]

     (fn [identifier]
       [:main.center
        [:div.w-full.block.mb-4
         ;{:class "lg:hidden md:hidden xl:hidden 2xl:hidden"}
         [ui-btn-action "Details" #(reset! current-tab :details)]
         [ui-btn-action "Upload images" #(reset! current-tab :images)]
         [ui-btn-action "Durations" #(reset! current-tab :durations)]]

        ;;[:code (str @values)]

        [:form.flex.flex-column.flex-row-l.justify-around-ns.w-full
         [:fieldset.ba.b--transparent.w-full

          {:class (str "lg:w-1/2 md:w-1/2 xl:w-1/2 2xl:w-1/2 "
                       (if (or (= :details @current-tab) (= nil @current-tab)) "block " "hidden"))}
          [:legend.text-2xl (if identifier "Edit plant" "Add plant")]

          [f/ui-form-input
           (r/cursor values [:values :plant|common-name])
           {:name "plant|common-name" :label "Common name"
            :tooltip "Common name"
            :placeholder "" :store-fn form}]

          [f/ui-form-input
           (r/cursor values [:values :plant|scientific-name])
           {:name "plant|scientific-name" :label "Scientific name"
            :tooltip "Scientific / Botanical Name"
            :placeholder "" :store-fn form}]

          [f/ui-form-input
           (r/cursor values [:values :plant|family])
           {:name "plant|family" :label "Family"
            :tooltip "Plant family"
            :placeholder "" :store-fn form}]

          ;;[ui-input "Common name" "plant|common-name" values form]
          ;;[ui-input "Scientific name" "plant|scientific-name" values form]
          ;;[ui-input "Family" "plant|family" values form]

          [s/ui-form-select
           (r/cursor values [:values :plant|hardiness])
           {:name "plant|hardiness" :label "Hardiness"
            :tooltip "Plant family"
            :options hardiness-options
            :placeholder "" :store-fn form}]

          [s/ui-form-select
           (r/cursor values [:values :plant|lifecycle])
           {:name "plant|lifecycle" :label "Lifecycle"
            :tooltip "Plant lifecycle"
            :options lifecycle-options
            :placeholder "" :store-fn form}]

          [s/ui-form-select
           (r/cursor values [:values :plant|type])
           {:name "plant|type" :label "Plant Type"
            :tooltip "Plant type"
            :options (fmt-plant-types->options)
            :placeholder "" :store-fn form}]

          #_[ui-select "Plant hardiness" "plant|hardiness" values hardiness-options form]
          #_[ui-select "Plant lifecycle" "plant|lifecycle" values lifecycle-options form]
          #_[ui-select "Plant Type" "plant|type" values (fmt-plant-types->options) form]

          #_[:h2 {:on-click #(swap! durations not)}
           (if @durations [:i.fas.fa-arrow-down]
               [:i.fas.fa-arrow-right])
           "Durations"]]

         (when (= :durations @current-tab)
           [:div.w-full 
            [ui-months "Sowing" :plant.season|sowing values]
            [ui-months "Planting" :plant.season|planting values]
            [ui-months "Flowering" :plant.season|flowering values]
            [ui-months "Harvesting" :plant.season|harvesting values]])

         (when (or (= :images @current-tab) (= :details @current-tab) (= nil @current-tab)) 
           [:fieldset.ba.b--transparent.ml2.w-full
            {:class (str "lg:block md:block xl:block 2xl:block lg:w-1/2 md:w-1/2 xl:w-1/2 2xl:w-1/2 "
                         (if (= :images @current-tab) "block w-full" "w-1/2 hidden"))}

            [:legend.text-2xl "Images"]
            [ui-image-drop "Drop Plant Images here" "plant.images|examples" values form]
            [ui-image-drop "Drop Fruit Images here" "plant.images|fruit" values form]
            [ui-image-drop "Drop Seed Images here" "plant.images|seed" values form]])]

        [button-progress-ajax
         "Add"
         {:on-click (fn [cb] (add-new-plant (:values @values) cb))
          :on-complete (fn [response]
                         (change-page {:id (-> response :body :document-id)}))}]]))))

(defn ui-form-gps []
  (let [values (r/atom {})]
    (fn []
      [:main.mw6.center.bg-white
       [:p "Enable GPS Follow & rotation"]
       [gps/ui-compass-popup {}]])))

(defn ui-form-settings []
  (let [values (r/atom {})
        form (partial update-atom-hm values)
        valid (r/atom false)]
    (fn []
      [:main.mw6.center
       [:form.measure.center
        [:fieldset.ba.b--transparent.ph0.mh0
         [:legend.text-2xl "Settings"]
         [ui-input "Plant names" "plant/family" values form]
         [ui-select "Plant names" "visual/names" values con/display-names form]
         [ui-select "Units" "visual/units" values units-options form]
         [:button {:on-click (fn [evt] (.preventDefault evt)
                               (add-new-plant @values prn))} "Add"]]]])))


